export default {
  title: 'Export Data',
  menu: 'Export Data',
  label: {
    startDate: 'Start Date',
    endDate: 'End Date',
    today: 'Today',
    yesterday: 'Yesterday',
    last7Days: '7 Days',
    last30Days: '30 Days',
    name: 'Name',
    operator: 'Action',
    export: 'Export',
    registration: 'Export Registration List',
    application: 'Export Application List',
    referral: 'Export Referral List',
    comment: 'Export Comment List',
    statusChange: 'Export Status Change List',
    group: 'Export Group List',
    hrLogin: 'Export HR Login List',
    jobPostingHistory: 'Export Job Posting History'
  },
  message: {
    dateRangeRequired: 'Please Choose Time',
    dateRangeError: 'Please Choose Correct Time'
  }
}
